import api from '../../../../api'

export const FETCH_SYNTHETIC_DETAILED_VEHICLE_PENDING = 'FETCH_SYNTHETIC_DETAILED_VEHICLE_PENDING'
export const FETCH_SYNTHETIC_DETAILED_VEHICLE_FULFILLED = 'FETCH_SYNTHETIC_DETAILED_VEHICLE_FULFILLED'
export const FETCH_SYNTHETIC_DETAILED_VEHICLE_REJECTED = 'FETCH_SYNTHETIC_DETAILED_VEHICLE_REJECTED'

export const DELETE_SYNTHETIC_DETAILED_VEHICLE_PENDING = 'DELETE_SYNTHETIC_DETAILED_VEHICLE_PENDING'
export const DELETE_SYNTHETIC_DETAILED_VEHICLE_FULFILLED = 'DELETE_SYNTHETIC_DETAILED_VEHICLE_FULFILLED'
export const DELETE_SYNTHETIC_DETAILED_VEHICLE_REJECTED = 'DELETE_SYNTHETIC_DETAILED_VEHICLE_REJECTED'

export const CHANGE_SYNTHETIC_DETAILED_VEHICLE = 'CHANGE_SYNTHETIC_DETAILED_VEHICLE'

export function changeSyntheticDetailedVehicle(name, value) {
  return dispatch => {
    dispatch({ type: CHANGE_SYNTHETIC_DETAILED_VEHICLE, payload: { name, value } })
  }
}

export function findAllSyntheticDetailedVehicles(filter, first = 12000, offset = 0) {
  
  return dispatch => new Promise((resolve, reject) => {

    dispatch({ type: FETCH_SYNTHETIC_DETAILED_VEHICLE_PENDING });

    api({
      method: 'post',
      data: {
        query: `
                query findAllSyntheticDetailedVehicles {
                  reportSinteticoDetalhadoVeiculo (input: {
                    veiculo: ${filter.veiculo}
                    dataHoraInicial: "${filter.dataHoraInicial}"
                    dataHoraFinal: "${filter.dataHoraFinal}"
                  } first: ${first} offset: ${offset}) {
                    diaMes 
                    motorista 
                    distancia 
                    tempoIgnicao 
                    tempoMotor 
                    tempoMarchaLenta 
                    tempoMovimento 
                    tempoChuva 
                    tempoExcessoVelocidade 
                    quantidadeEventosVelocidade 
                    maximaVelocidadeSeco
                    maximaVelocidadeChuva 
                    quantidadeEventosBanguela 
                    maximaBanguela 
                    tempoExcessoRPM 
                    quantidadeEventosRPM 
                    maximaRPM 
                    quantidadeEventosTemperatura 
                    maximaTemperatura 
                    quantidadeEventosFreadaBrusca 
                    maximaFreadaBrusca 
                    quantidadeEventosAceleracaoParado 
                    maximaAceleracaoParado 
                    quantidadeEventosAceleracaoMovimento 
                    maximaAceleracaoMovimento
                  }
                }
                `
      }
    }).then((result) => {
      const { errors, data } = result.data
      if (errors) {
        dispatch({ type: FETCH_SYNTHETIC_DETAILED_VEHICLE_REJECTED, payload: errors });
        reject(errors);
      } else {
        const { reportSinteticoDetalhadoVeiculo } = data
        dispatch({ type: FETCH_SYNTHETIC_DETAILED_VEHICLE_FULFILLED, payload: reportSinteticoDetalhadoVeiculo });
        resolve(data);
      }
    }).catch((error) => {
      dispatch({ type: FETCH_SYNTHETIC_DETAILED_VEHICLE_REJECTED, error });
      reject(error);
    });

  });

}
